export default {
  toucanTitle: 'Mutualize in complete autonomy',
  colinorTitle: 'Welcome to Colinor',
  colinorSubtitle: 'Log in to share transport',
  toucanSubtitle: 'The collaborative platform for your company',
  login: 'Log in',
  poweredBy: 'Powered by',
  toucan: 'Toucan Solutions',
};
